import HomeContainer from './Home.container';

export default HomeContainer;
